<table mat-table [dataSource]="jobsList" matSort>
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef>ID</th>
    <td mat-cell *matCellDef="let job"> {{job.id | shortenJobID}}</td>
  </ng-container>

  <ng-container matColumnDef="member">
    <th mat-header-cell *matHeaderCellDef>MEMBER</th>
    <td mat-cell *matCellDef="let job"> {{job.memberName}}</td>
  </ng-container>

  <ng-container matColumnDef="address">
    <th mat-header-cell *matHeaderCellDef>ADDRESS</th>
    <td mat-cell *matCellDef="let job"> {{job.address}}</td>
  </ng-container>

  <ng-container matColumnDef="received">
    <th mat-header-cell *matHeaderCellDef>RECEIVED</th>
    <td mat-cell *matCellDef="let job">
      {{job.received | date:'dd/MM/yyyy'}}
    </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th class="cell-status" mat-header-cell *matHeaderCellDef>STATUS</th>
    <td class="cell-status-data" mat-cell *matCellDef="let job">
      <span class="status-label" [ngClass]="job.statusSnakeCase">{{job.status}}</span>
    </td>
  </ng-container>

  <ng-container matColumnDef="finals">
    <th mat-header-cell *matHeaderCellDef>#FINALS</th>
    <td mat-cell *matCellDef="let job">
      <span>{{job.numOfFinals}}</span>
    </td>
  </ng-container>

  <ng-container matColumnDef="raws">
    <th mat-header-cell *matHeaderCellDef>#RAWS</th>
    <td mat-cell class="raws-col" *matCellDef="let job"
    >
      <span #tooltip="matTooltip"
            [matTooltip]="job?.notifications?.newRaws ? 'New download available': null"
            matTooltipClass="tooltiptext"
            matTooltipPosition="left"
      >
        {{job.numOfRaws || 20}}
      </span>
      <span
        *ngIf="job?.notifications?.newRaws;"
        matBadge="0"
        matBadgeOverlap="false"
        class="hide-text"></span>
    </td>
  </ng-container>

  <ng-container matColumnDef="brief">
    <th class="cell-brief" mat-header-cell *matHeaderCellDef>BRIEF</th>
    <td class="cell-brief brief-col" mat-cell *matCellDef="let job">
      <button mat-icon-button class="btn"
              #tooltip="matTooltip"
              [matTooltip]="job.brief || 'No brief'"
              matTooltipClass="tooltiptext"
              matTooltipPosition="before"
              (click)="openBriefModal(job)"
              [disabled]="job.SNAKE_CASE !== 'image_processing'">
        <svg width="20px" height="23px" viewBox="0 0 20 23" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <g id="Processor" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Processor---Jobs" transform="translate(-857.000000, -256.000000)" fill="#2F9BBF" fill-rule="nonzero">
              <g id="Group-6" transform="translate(223.000000, 184.000000)">
                <g id="Group-19" transform="translate(632.000000, 20.000000)">
                  <g id="0217-document" transform="translate(2.000000, 52.000000)">
                    <path
                      d="M17.5526316,23 L1.81578947,23 C0.814684211,23 0,22.1853158 0,21.1842105 L0,1.81578947 C0,0.814684211 0.814684211,0 1.81578947,0 L17.5526316,0 C18.5537368,0 19.3684211,0.814684211 19.3684211,1.81578947 L19.3684211,21.1842105 C19.3684211,22.1853158 18.5537368,23 17.5526316,23 Z M1.81578947,1.21052632 C1.48168421,1.21052632 1.21052632,1.48168421 1.21052632,1.81578947 L1.21052632,21.1842105 C1.21052632,21.5183158 1.48168421,21.7894737 1.81578947,21.7894737 L17.5526316,21.7894737 C17.8867368,21.7894737 18.1578947,21.5183158 18.1578947,21.1842105 L18.1578947,1.81578947 C18.1578947,1.48168421 17.8867368,1.21052632 17.5526316,1.21052632 L1.81578947,1.21052632 Z"
                      id="Shape"></path>
                    <path
                      d="M12.7105263,4.84210526 L4.23684211,4.84210526 C3.90273684,4.84210526 3.63157895,4.57094737 3.63157895,4.23684211 C3.63157895,3.90273684 3.90273684,3.63157895 4.23684211,3.63157895 L12.7105263,3.63157895 C13.0446316,3.63157895 13.3157895,3.90273684 13.3157895,4.23684211 C13.3157895,4.57094737 13.0446316,4.84210526 12.7105263,4.84210526 Z"
                      id="Shape"></path>
                    <path
                      d="M15.1315789,7.26315789 L4.23684211,7.26315789 C3.90273684,7.26315789 3.63157895,6.992 3.63157895,6.65789474 C3.63157895,6.32378947 3.90273684,6.05263158 4.23684211,6.05263158 L15.1315789,6.05263158 C15.4656842,6.05263158 15.7368421,6.32378947 15.7368421,6.65789474 C15.7368421,6.992 15.4656842,7.26315789 15.1315789,7.26315789 Z"
                      id="Shape"></path>
                    <path
                      d="M15.1315789,9.68421053 L4.23684211,9.68421053 C3.90273684,9.68421053 3.63157895,9.41305263 3.63157895,9.07894737 C3.63157895,8.74484211 3.90273684,8.47368421 4.23684211,8.47368421 L15.1315789,8.47368421 C15.4656842,8.47368421 15.7368421,8.74484211 15.7368421,9.07894737 C15.7368421,9.41305263 15.4656842,9.68421053 15.1315789,9.68421053 Z"
                      id="Shape"></path>
                    <path
                      d="M10.2894737,12.1052632 L4.23684211,12.1052632 C3.90273684,12.1052632 3.63157895,11.8341053 3.63157895,11.5 C3.63157895,11.1658947 3.90273684,10.8947368 4.23684211,10.8947368 L10.2894737,10.8947368 C10.6235789,10.8947368 10.8947368,11.1658947 10.8947368,11.5 C10.8947368,11.8341053 10.6235789,12.1052632 10.2894737,12.1052632 Z"
                      id="Shape"></path>
                    <path
                      d="M15.1315789,16.9473684 L4.23684211,16.9473684 C3.90273684,16.9473684 3.63157895,16.6762105 3.63157895,16.3421053 C3.63157895,16.008 3.90273684,15.7368421 4.23684211,15.7368421 L15.1315789,15.7368421 C15.4656842,15.7368421 15.7368421,16.008 15.7368421,16.3421053 C15.7368421,16.6762105 15.4656842,16.9473684 15.1315789,16.9473684 Z"
                      id="Shape"></path>
                    <path
                      d="M12.7105263,19.3684211 L4.23684211,19.3684211 C3.90273684,19.3684211 3.63157895,19.0972632 3.63157895,18.7631579 C3.63157895,18.4290526 3.90273684,18.1578947 4.23684211,18.1578947 L12.7105263,18.1578947 C13.0446316,18.1578947 13.3157895,18.4290526 13.3157895,18.7631579 C13.3157895,19.0972632 13.0446316,19.3684211 12.7105263,19.3684211 Z"
                      id="Shape"></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </button>
    </td>
  </ng-container>

  <ng-container matColumnDef="add">
    <th class="cell-brief" mat-header-cell *matHeaderCellDef>ADD</th>
    <td class="cell-brief brief-col" mat-cell *matCellDef="let job">
      <button mat-icon-button class="btn"
              (click)="addAssets(job)"
              [disabled]="job.SNAKE_CASE !== 'image_processing'">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
          <path fill="#2F9BBF"
                d="M520-410.001h59.999v-120h120v-59.998h-120v-120H520v120H400v59.998h120v120Zm-197.692 150q-30.308 0-51.307-21-21-21-21-51.308v-455.382q0-30.308 21-51.308 20.999-21 51.307-21h455.383q30.307 0 51.307 21 21 21 21 51.308v455.382q0 30.308-21 51.308t-51.307 21H322.308Zm0-59.999h455.383q4.615 0 8.462-3.846 3.846-3.847 3.846-8.463v-455.382q0-4.616-3.846-8.463-3.847-3.846-8.462-3.846H322.308q-4.616 0-8.462 3.846-3.847 3.847-3.847 8.463v455.382q0 4.616 3.847 8.463 3.846 3.846 8.462 3.846ZM182.309-120.003q-30.307 0-51.307-21-21-21-21-51.307v-515.381h59.999v515.381q0 4.616 3.846 8.462 3.847 3.847 8.462 3.847h515.382v59.998H182.309ZM309.999-800v480-480Z"/>
        </svg>
      </button>
    </td>
  </ng-container>

  <ng-container matColumnDef="pricing">
    <th mat-header-cell *matHeaderCellDef>PRICING</th>
    <td mat-cell *matCellDef="let job">
      <button mat-icon-button (click)="openJobPricing(job)">
        <svg width="30" height="30" viewBox="0 0 30 30" fill="#319bbe" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M14.6341 30C10.7252 30 7.05023 28.4398 4.2862 25.6066C1.52218 22.7735 0 19.0066 0 15C0 10.9934 1.52224 7.22654 4.2862 4.39336C7.05017 1.56018 10.7252 0 14.6341 0C18.5431 0 22.2181 1.56023 24.9821 4.39336C27.7461 7.22648 29.2683 10.9934 29.2683 15C29.2683 19.0066 27.7461 22.7735 24.9821 25.6066C22.2181 28.4398 18.5431 30 14.6341 30ZM14.6341 1.875C7.57351 1.875 1.82927 7.76285 1.82927 15C1.82927 22.2371 7.57351 28.125 14.6341 28.125C21.6948 28.125 27.439 22.2371 27.439 15C27.439 7.76285 21.6948 1.875 14.6341 1.875Z"/>
          <path
            d="M14.6342 14.0625C13.3733 14.0625 12.3476 13.0111 12.3476 11.7188C12.3476 10.4264 13.3733 9.375 14.6342 9.375C15.895 9.375 16.9207 10.4264 16.9207 11.7188C16.9207 12.2365 17.3302 12.6562 17.8354 12.6562C18.3405 12.6562 18.75 12.2365 18.75 11.7188C18.75 9.71479 17.3793 8.03391 15.5488 7.60629V6.5625C15.5488 6.04477 15.1393 5.625 14.6342 5.625C14.129 5.625 13.7195 6.04477 13.7195 6.5625V7.60629C11.889 8.03391 10.5183 9.71479 10.5183 11.7188C10.5183 14.045 12.3647 15.9375 14.6342 15.9375C15.895 15.9375 16.9207 16.9889 16.9207 18.2812C16.9207 19.5736 15.895 20.625 14.6342 20.625C13.3733 20.625 12.3476 19.5736 12.3476 18.2812C12.3476 17.7635 11.9381 17.3438 11.4329 17.3438C10.9278 17.3438 10.5183 17.7635 10.5183 18.2812C10.5183 20.2852 11.889 21.9661 13.7195 22.3937V23.4375C13.7195 23.9552 14.129 24.375 14.6342 24.375C15.1393 24.375 15.5488 23.9552 15.5488 23.4375V22.3937C17.3793 21.9661 18.75 20.2852 18.75 18.2812C18.75 15.955 16.9037 14.0625 14.6342 14.0625Z"/>
        </svg>
      </button>
    </td>
  </ng-container>

  <ng-container matColumnDef="history">
    <th mat-header-cell *matHeaderCellDef>History</th>
    <td mat-cell *matCellDef="let job">
      <button mat-icon-button (click)="goToTimeline(job)" class="btn btn-blue history-btn">
        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="-5 -6 50 50" fill="#319bbe">
          <g>
            <g>
              <g>
                <path
                  d="M23,8c0,1.1-0.9,2-2,2c-0.18,0-0.35-0.02-0.51-0.07l-3.56,3.55C16.98,13.64,17,13.82,17,14c0,1.1-0.9,2-2,2s-2-0.9-2-2 c0-0.18,0.02-0.36,0.07-0.52l-2.55-2.55C10.36,10.98,10.18,11,10,11s-0.36-0.02-0.52-0.07l-4.55,4.56C4.98,15.65,5,15.82,5,16 c0,1.1-0.9,2-2,2s-2-0.9-2-2s0.9-2,2-2c0.18,0,0.35,0.02,0.51,0.07l4.56-4.55C8.02,9.36,8,9.18,8,9c0-1.1,0.9-2,2-2s2,0.9,2,2 c0,0.18-0.02,0.36-0.07,0.52l2.55,2.55C14.64,12.02,14.82,12,15,12s0.36,0.02,0.52,0.07l3.55-3.56C19.02,8.35,19,8.18,19,8 c0-1.1,0.9-2,2-2S23,6.9,23,8z"/>
              </g>
            </g>
          </g>
        </svg>
      </button>
    </td>
  </ng-container>

  <ng-container matColumnDef="assets">
    <th class="cell-assets" mat-header-cell *matHeaderCellDef>ASSETS</th>
    <td class="cell-assets-data" mat-cell *matCellDef="let job">
      <mat-progress-bar *ngIf="downloadProgress[job.id] > -1; else downloadButton"
                        [value]="downloadProgress[job.id]"></mat-progress-bar>
      <ng-template #downloadButton>
        <button mat-icon-button class="btn btn-blue assets-btn" (click)="openAssetsDownloadDialog(job)"
                [disabled]="downloadProgress[job.id] === 0">
          <svg width="25px" height="25px" viewBox="0 0 25 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Processor" stroke="none" stroke-width="2" fill="none" fill-rule="evenodd">
              <g id="Processor---Jobs" transform="translate(-1320.000000, -259.000000)" fill="#2F9BBF"
                 fill-rule="nonzero">
                <g id="Group-6" transform="translate(223.000000, 184.000000)">
                  <g id="Group-2" transform="translate(1096.000000, 20.000000)">
                    <g id="Group-13" transform="translate(1.000000, 55.000000)">
                      <g id="Group-9-Copy-2">
                        <g id="0192-folder-upload">
                          <path
                            d="M22.8207237,19.1666667 L1.85032895,19.1666667 C0.830180921,19.1666667 0,18.3254167 0,17.2916667 L0,4.16666667 C0,3.72666667 0.146792763,3.09666667 0.340460526,2.70291667 L1.02261513,1.32041667 C1.27672697,0.804166667 1.8984375,0.415416667 2.46710526,0.415416667 L11.1019737,0.415416667 C11.6706414,0.415416667 12.2911184,0.804166667 12.5464638,1.32041667 L13.2286184,2.70291667 C13.2754934,2.79916667 13.464227,2.91666667 13.5690789,2.91666667 L22.8207237,2.91666667 C23.8408717,2.91666667 24.6710526,3.75791667 24.6710526,4.79166667 L24.6710526,17.2916667 C24.6710526,18.3254167 23.8408717,19.1666667 22.8207237,19.1666667 Z M2.46710526,1.66666667 C2.36101974,1.66666667 2.17351974,1.78416667 2.12664474,1.88041667 L1.44449013,3.26291667 C1.3359375,3.48291667 1.23355263,3.92166667 1.23355263,4.16791667 L1.23355263,17.2929167 C1.23355263,17.6379167 1.50986842,17.9179167 1.85032895,17.9179167 L22.8207237,17.9179167 C23.1611842,17.9179167 23.4375,17.6379167 23.4375,17.2929167 L23.4375,4.79291667 C23.4375,4.44791667 23.1611842,4.16791667 22.8207237,4.16791667 L13.5690789,4.16791667 C13.0004112,4.16791667 12.3787007,3.77916667 12.1245888,3.26291667 L11.4424342,1.88041667 C11.3955592,1.78416667 11.2068257,1.66666667 11.1019737,1.66666667 L2.46710526,1.66666667 Z"
                            id="Shape"></path>
                          <path
                            d="M15.8560855,9.97416667 L12.1554276,6.22416667 C11.9148849,5.98041667 11.5238487,5.98041667 11.2833059,6.22416667 L7.58264803,9.97416667 C7.34210526,10.2179167 7.34210526,10.6141667 7.58264803,10.8579167 C7.82319079,11.1016667 8.21422697,11.1016667 8.45476974,10.8579167 L11.1019737,8.17541667 L11.1019737,14.7916667 C11.1019737,15.1366667 11.3782895,15.4166667 11.71875,15.4166667 C12.0592105,15.4166667 12.3355263,15.1366667 12.3355263,14.7916667 L12.3355263,8.17541667 L14.9827303,10.8579167 C15.1036184,10.9804167 15.2615132,11.0404167 15.4194079,11.0404167 C15.5773026,11.0404167 15.7351974,10.9791667 15.8560855,10.8579167 C16.0966283,10.6141667 16.0966283,10.2179167 15.8560855,9.97416667 L15.8560855,9.97416667 Z"
                            id="Shape"
                            transform="translate(11.719367, 10.729010) rotate(-180.000000) translate(-11.719367, -10.729010) "></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </button>
      </ng-template>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="columnHeaders"></tr>
  <tr mat-row *matRowDef="let rowData; columns: columnHeaders;"></tr>
</table>
<mat-progress-bar *ngIf="(jobsLoading$ | async)" mode="indeterminate"></mat-progress-bar>
<mat-paginator [length]="paginatorControl.length"
               [pageSize]="paginatorControl.pageSize"
               [pageSizeOptions]="paginatorControl.pageSizeOptions"
               (page)="setPaginator($event)"
               #paginator>
</mat-paginator>
